import moment from "moment";
import { ExpandText } from "../components/common/Common";
import { Tag } from "antd";

export function numberFormatter(value) {
  var formatted = value || 0;
  return Number(formatted).toLocaleString();
}

export function currencyFormatter(value) {
  return `UGX ${numberFormatter(value)}`;
}

export function dateFormat(value) {
  return value?.toDate().toDateString();
}

export function timeFormat(value) {
  return value?.toDate().toLocaleTimeString();
}

export function dateTimeFormat(value, format, onlyText) {
  if (onlyText)
    return moment(value?.toDate()).format(format || "DD MMM YYYY @ H:mm");
  return (
    <ExpandText
      hidden={
        <Tag style={{ margin: 0 }}>
          {moment(value?.toDate()).format("H:mm")}
        </Tag>
      }
    >
      <Tag style={{ margin: 0 }}>
        {moment(value?.toDate()).format(format || "DD MMM YYYY")}
      </Tag>
    </ExpandText>
  );
}
